import React from "react";
import "./WhyChoose.css";
import bg from "./bg-choose.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFigma,
} from "@fortawesome/free-brands-svg-icons";
import {
  faSackDollar,
  faUsers,
  faCircleDollarToSlot,
  faMobileScreenButton,
  faShield,
  faMoneyBill,
  faChartLine

} from "@fortawesome/free-solid-svg-icons";
const DesktopWhyChoose = () => {
  return (
    <>
    <main className="why-choose-area">
    <section className="features" id="features"  >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="block-text center">
                <h3 className="title">Why Choose WLF Mobile.?</h3>
                <p className="fs-17 mt-12">
                  Ventures Federal Trading Commission official characteristics
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-md-6">
              <div
                className="choose__box aos-init"
                data-aos="fade-up"
                data-aos-duration="800"
              >
                <div className="choose__box-icon center">
                  <div className="icon">
                    <FontAwesomeIcon icon={faSackDollar} />
                  </div>
                  <div className="content">
                    <h5 className="h5">Wide Range of Investment Options</h5>
                    <p className="mt-9">
                    WLF Mobile allows you to invest in diverse assets, including digital currencies, gold, stocks, and forex. This variety allows you to diversify your portfolio and manage risk effectively, tailoring your investments to meet your financial goals.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div
                className="choose__box aos-init"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <div className="choose__box-icon center">
                  <div className="icon">
                  <FontAwesomeIcon icon={faShield} />
                  </div>
                  <div className="content">
                    <h5 className="h5">Strong Security Measures</h5>
                    <p className="mt-9">
                    Security is a top priority at WLF Mobile. The platform employs state-of-the-art security protocols, including encryption and two-factor authentication, to safeguard your personal information and investments. Additionally, WLF Mobile adheres to regulatory standards, providing a secure and trustworthy investment environment.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div
                className="choose__box aos-init"
                data-aos="fade-up"
                data-aos-duration="1200"
              >
                <div className="choose__box-icon center">
                  <div className="icon">
                  <FontAwesomeIcon icon={faUsers} />
                  </div>
                  <div className="content">
                    <h5 className="h5">Responsive Customer Support</h5>
                    <p className="mt-9">
                    With AI and human-based responsive and knowledgeable customer support, WLF Mobile ensures that you have the assistance you need whenever you need it. Whether you have questions about the platform or need help with a specific transaction, their support team is there to help.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div
                className="choose__box aos-init"
                data-aos="fade-up"
                data-aos-duration="1400"
              >
                <div className="choose__box-icon center">
                  <div className="icon">
                  <FontAwesomeIcon icon={faCircleDollarToSlot} />
                  </div>
                  <div className="content">
                    <h5 className="h5">Customizable Investment Strategies</h5>
                    <p className="mt-9">
                    WLF Mobile allows you to tailor investment strategies to your goals and risk tolerance. Whether you're looking for long-term growth or short-term gains, the platform provides the flexibility to adjust your approach as needed.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div
                className="choose__box aos-init"
                data-aos="fade-up"
                data-aos-duration="800"
              >
                <div className="choose__box-icon center">
                  <div className="icon">
                  <FontAwesomeIcon icon={faChartLine} />
                  </div>
                  <div className="content">
                    <h5 className="h5">Cutting-Edge Technology</h5>
                    <p className="mt-9">
                    WLF Mobile platform utilises advanced technology to provide real-time data, sophisticated trading tools, and robust analytics. These features enable you to make well-informed investment decisions and stay ahead in the fast-paced financial markets.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div
                className="choose__box aos-init"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <div className="choose__box-icon center">
                  <div className="icon">
                  <FontAwesomeIcon icon={faFigma} />
                  </div>
                  <div className="content">
                    <h5 className="h5">User-Friendly Interface</h5>
                    <p className="mt-9">
                    WLF Mobile's user-friendly interface makes it easy for both novice and experienced investors to navigate and manage their investments. The platform's intuitive design ensures a smooth and efficient user experience.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div
                className="choose__box aos-init"
                data-aos="fade-up"
                data-aos-duration="1200"
              >
                <div className="choose__box-icon center">
                  <div className="icon">
                  <FontAwesomeIcon icon={faMobileScreenButton} />
                  </div>
                  <div className="content">
                    <h5 className="h5">Mobile Accessibility</h5>
                    <p className="mt-9">
                    WLF Mobile's app allows you to manage your investments on the go. It provides full functionality, allowing you to trade, monitor your portfolio, and access market information anytime, anywhere.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div
                className="choose__box aos-init"
                data-aos="fade-up"
                data-aos-duration="1400"
              >
                <div className="choose__box-icon center">
                  <div className="icon">
                  <FontAwesomeIcon icon={faMoneyBill} />
                  </div>
                  <div className="content">
                    <h5 className="h5">Competitive and Transparent Fees</h5>
                    <p className="mt-9">
                    WLF Mobile offers competitive fees and a transparent pricing structure, allowing you to maximise your returns without worrying about hidden costs. This ensures you can invest confidently, knowing exactly what you are paying for.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
     
    </>
  );
};

export default DesktopWhyChoose;
